import React, { useRef } from "react";
import { Link } from "react-router-dom";
import { dishes, fullName } from "../data/dishes";

// Seven-item selector. `tabs` mode drives the homepage panel with full
// arrow/Home/End keyboard support; `links` mode routes to dish pages.
export default function DishSwitcher({ mode = "links", selected = 0, currentId, onSelect, panelId }) {
  const refs = useRef([]);

  const onKeyDown = (e, i) => {
    let n = null;
    if (e.key === "ArrowRight") n = (i + 1) % dishes.length;
    else if (e.key === "ArrowLeft") n = (i - 1 + dishes.length) % dishes.length;
    else if (e.key === "Home") n = 0;
    else if (e.key === "End") n = dishes.length - 1;
    if (n === null) return;
    e.preventDefault();
    onSelect(n);
    const el = refs.current[n];
    if (el) el.focus();
  };

  if (mode === "tabs") {
    return (
      <div className="ro-switcher" role="tablist" aria-label="Choose a RollOver dish">
        {dishes.map((d, i) => (
          <button
            key={d.id}
            ref={(el) => (refs.current[i] = el)}
            type="button"
            role="tab"
            id={`ro-dish-tab-${i}`}
            aria-selected={i === selected}
            aria-controls={panelId}
            tabIndex={i === selected ? 0 : -1}
            onClick={() => onSelect(i)}
            onKeyDown={(e) => onKeyDown(e, i)}
            className="ro-switcher__item"
          >
            <img src={d.image} alt="" width="90" height="90" />
            <span className="ro-switcher__caption">{d.short}</span>
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="ro-switcher" aria-label="Other dishes">
      {dishes.map((d) => (
        <Link
          key={d.id}
          to={`/menu/${d.id}`}
          className={`ro-switcher__item ${d.id === currentId ? "is-current" : ""}`}
          aria-current={d.id === currentId ? "page" : undefined}
          aria-label={fullName(d)}
        >
          <img src={d.image} alt="" width="90" height="90" />
          <span className="ro-switcher__caption">{d.short}</span>
        </Link>
      ))}
    </div>
  );
}
